import { useBlockProps } from '@wordpress/block-editor';

const Edit = (props) => {
	const {
		attributes: {
			buttonBgColor,
			buttonTextColor,
			buttonPaddingLR,
			buttonPaddingTB,
			buttonFontSize,
			buttonBorderRadius,
			buttonWidth,
			buttonText,
		},
	} = props;

	const blockProps = useBlockProps({
		className: 'wc-file-uploader',
	});

	return (
		<div {...blockProps}>
			<div
				className="wc-file-uploaded-button"
				style={{
					cursor: 'pointer',
					textAlign: 'center',
					backgroundColor: '#157cfc',
					color: '#ffffff',
					borderRadius: '6px',
					padding: '6px 16px',
					fontSize: '16px',
					width: 'auto',
				}}
			>
				{buttonText || 'Upload'}
			</div>
		</div>
	);
};

export default Edit;
